import { render, staticRenderFns } from "./RegisterNetwork.vue?vue&type=template&id=55bf5e70"
import script from "./RegisterNetwork.vue?vue&type=script&lang=ts"
export * from "./RegisterNetwork.vue?vue&type=script&lang=ts"
import style0 from "./RegisterNetwork.vue?vue&type=style&index=0&id=55bf5e70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports